<template>
    <UiHeaderButton
        v-if="$page.props.advisor"
        :title="lang('advisor::advisor.title')"
        dusk="advisor-button"
        @click.stop="drawer.toggle()"
    >
        <icon icon="phosphor/regular/sparkle" class="w-5 h-5 cursor-pointer"></icon>
    </UiHeaderButton>
</template>

<script setup lang="ts">
import { lang } from '@/lang/composable';
import { useAdvisorDrawer } from '@src/Advisor/Pages/composables/useAdvisorDrawer';

const drawer = useAdvisorDrawer();
</script>
